/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-09-28
 * @brief EHP 사용자 메일 인증 개발
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useAsync } from "react-async";
import { useRecoilValue } from "recoil";
import "/static/css/login.css";
// recoil
import { getApiLangState } from "../../../recoil/langState";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CONST from "../../../utils/Const";
import OkEhpCertification from "./OkEhpCertification";
import NoEhpCertification from "./NoEhpCertification";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
/**
 * @brief EHP 이메일 인증 컴포넌트
 * @param -
 * @returns react components
 */
function EhpCertification() {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const [ok, setOk] = useState("");
    // params 
    const location = useLocation();
    //params - search
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();
    let email = params.get(CONST.STR_EMAIL);
    let key = params.get(CONST.STR_KEY);
    const { data: data, run } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        // deferFn: HttpUtil.Http,
        httpMethod: "POST",
        appPath: "/api/v2/auth/key/valid",
        appQuery: {
            userId: email,
            token: key,
            language: apiLang,
            // (langs ==='')?Korean
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setOk("ok");
            }
            else {
                localStorage.setItem(CONST.STR_EMAIL, email);
                if (data.errorList.filter((err) => err.field == "userId")) {
                    alert(data.errorList.map(err => err.msg));
                    navigate("/");
                }
                else {
                    setOk("no");
                }
            }
        }
    }, [data]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "login" },
            React.createElement("div", { className: "login__left" },
                React.createElement("div", { className: "left__top" },
                    React.createElement("span", { className: "hide" }, "LS")),
                React.createElement("div", { className: "left__center" },
                    React.createElement("p", null, "Welcome to LS ELECTRIC"),
                    React.createElement("h1", null,
                        React.createElement("img", { src: require("/static/img/logo_login_title.png"), alt: "e-Health Portal" }))),
                React.createElement("p", { className: "left__bottom" }, "LS ELECTRIC \u00A9")),
            (ok == "") &&
                React.createElement("div", { className: "login__right webmailok" },
                    React.createElement("h2", null,
                        React.createElement("p", { className: "tit" }, "\uC778\uC99D \uC911\uC785\uB2C8\uB2E4")),
                    React.createElement("div", { className: "login__form" },
                        React.createElement("form", { action: "#", method: "", name: "loginform" },
                            React.createElement("fieldset", null)))),
            (ok == "ok") &&
                React.createElement(OkEhpCertification, null),
            (ok == "no") &&
                React.createElement(NoEhpCertification, null))));
}
export default EhpCertification;
